import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const IqcInboxPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.IqcInboxPage })),
);
const IqcLotDetailPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.IqcLotDetailPage })),
);
const NcrListPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.NcrListPage })),
);
const NcrDetailPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.NcrDetailPage })),
);
const QaReleaseListPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.QaReleaseListPage })),
);
const QaReleaseDetailPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.QaReleaseDetailPage })),
);
const FqcInboxPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.FqcInboxPage })),
);
const FqcLotDetailPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.FqcLotDetailPage })),
);
const DeviationListPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.DeviationListPage })),
);
const DeviationDetailPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.DeviationDetailPage })),
);
const MobileQualityPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.MobileQualityPage })),
);
const MobileQualityDetailPage = lazy(() =>
  import("@/modules/qms").then((m) => ({ default: m.MobileQualityDetailPage })),
);

export const qmsRoutes: RouteObject[] = [
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.QmsIqcList, PermissionCodes.QmsFqcList, PermissionCodes.QmsInspectionExecute,
                  PermissionCodes.QmsNcrList, PermissionCodes.QmsNcrManage,
                  PermissionCodes.QmsDeviationList, PermissionCodes.QmsDeviationManage,
                  PermissionCodes.QmsReleaseList, PermissionCodes.QmsReleaseDecide,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "qms/iqc",
                element: (
                  <LazyPage>
                    <IqcInboxPage />
                  </LazyPage>
                ),
              },
              {
                path: "qms/iqc/:lotCode",
                element: (
                  <LazyPage>
                    <IqcLotDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "qms/ncrs",
                element: (
                  <LazyPage>
                    <NcrListPage />
                  </LazyPage>
                ),
              },
              {
                path: "qms/ncrs/:ncrId",
                element: (
                  <LazyPage>
                    <NcrDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "qms/releases",
                element: (
                  <LazyPage>
                    <QaReleaseListPage />
                  </LazyPage>
                ),
              },
              {
                path: "qms/releases/:lotCode",
                element: (
                  <LazyPage>
                    <QaReleaseDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "qms/fqc",
                element: (
                  <LazyPage>
                    <FqcInboxPage />
                  </LazyPage>
                ),
              },
              {
                path: "qms/fqc/:lotCode",
                element: (
                  <LazyPage>
                    <FqcLotDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "qms/deviations",
                element: (
                  <LazyPage>
                    <DeviationListPage />
                  </LazyPage>
                ),
              },
              {
                path: "qms/deviations/:deviationId",
                element: (
                  <LazyPage>
                    <DeviationDetailPage />
                  </LazyPage>
                ),
              },
        ],
      },
];

export const qmsFieldRoutes: RouteObject[] = [
  {
    path: "qms",
    element: (
      <LazyPage>
        <MobileQualityPage shell="field" />
      </LazyPage>
    ),
  },
  {
    path: "qms/:type/:lotCode",
    element: (
      <LazyPage>
        <MobileQualityDetailPage shell="field" />
      </LazyPage>
    ),
  },
];
